import { css } from 'emotion';

import { colors, getRGBA } from '@cobliteam/base-components';

export const hover = css`
  :hover {
    min-width: 150px;
    background-color: ${getRGBA(colors.primary.disabled, 0.4)};

    > span > span:first-child {
      margin: 0 10px 0 0;
    }
    > span > span:last-child {
      display: inline-block;
    }
  }
`;

export const howToUseDropDownButton = css`
  border-radius: 5px;
  background-color: ${getRGBA(colors.primary.disabled, 0.2)};
  height: 26px;
  min-width: 26px;
  padding: inherit;

  > span > span:first-child {
    margin: 0;
  }
  > span > span:last-child {
    display: none;
    color: ${colors.primary.default};
  }

  @media (min-width: 1095px) {
    ${hover}
  }
`;

export const actionButton = css`
  padding: 20px;
  margin-right: 20px;
`;

export const actionIcon = css`
  width: 16px;
  height: 16px;
`;
